export default {
  pharmaplan: 'PharmaGap',
  urgentCall: 'PharmaGap',
  resetPassDesc:
    'Votre adresse e-mail que vous utilisez pour vous connecter à PharmaGap',
  pharmaPlan: 'PharmaGap',
  pageHeaderTitle: 'PharmaGap - {0}',
  termsAndConditionsHeader: 'Conditions de service de PharmaGap',
  pharmaplanCharges: '*PharmaGap facture {0}% du coût de la réservation',
  updateOperationMessage:
    "Pour continuer avec l'application Pharmagap, veuillez mettre à jour les informations opérationnelles.",
  adminPharmaplan: 'Administrateur PharmaGap',
  pharmaplanID: 'Pharmagap ID',
  changeEmailConfirmation:
    'Cela nécessite de passer à un utilisateur de courriel PharmaGap au lieu de {0} et de créer un mot de passe. Ne vous inquiétez pas, nous vous guiderons à travers les étapes !',
  pharmaplanGrossProfit: 'Bénéfice Brut de PharmaGap',
  pharmaplanStatistics: 'Statistiques de PharmaGap',
  chatGuide:
    "Vous pouvez facilement joindre l'équipe de soutien PharmaGap pour toute question ou préoccupation en démarrant un chat directement depuis cette section.",
};
